import { Box, Col, Row } from '@opendoor/atoms/box';
import { Image } from '@opendoor/atoms/image';
import { Text } from '@opendoor/atoms/text';
import { cn } from '@opendoor/atoms/utils';

import { LANDING_MEDIA, VALUE_PROP_ICONS } from './landingMedia';
import { BODY_COPY, SECTION, SECTION_HEADING, SECTION_INNER } from './landingStyles';

const VALUE_PROPS = [
  {
    icon: VALUE_PROP_ICONS.speed,
    title: 'It’s hassle-free and quick',
    body: 'Submit your client’s offer in just a few minutes - attach the supporting documents as you go, or add them later.',
  },
  {
    icon: VALUE_PROP_ICONS.paperwork,
    title: 'We prepare the paperwork for you',
    body: 'Once your offer moves forward, we draft the documents for your buyer, so there’s less for you to chase down.',
  },
  {
    icon: VALUE_PROP_ICONS.alerts,
    title: 'Stay on top of every counter-offer',
    body: 'See every counter-offer the instant it lands - no waiting, no guessing.',
  },
] as const;

const WhySubmitOnline = () => (
  <Box as="section" className={SECTION}>
    <Row className={cn(SECTION_INNER, 'gap-10 lg:flex-row lg:items-center')}>
      <Image
        src={LANDING_MEDIA.offerDashboard.src}
        alt={LANDING_MEDIA.offerDashboard.alt}
        className="w-full rounded-[40px] object-cover lg:h-[642px] lg:w-[595px] lg:shrink-0"
      />
      <Col className="gap-10 lg:w-[572px] lg:gap-20">
        <Text as="h2" className={cn(SECTION_HEADING, 'text-od-content-primary')}>
          Why submit online?
        </Text>
        <Col className="gap-8">
          {VALUE_PROPS.map((prop, index) => (
            <Row key={prop.title} className="items-start gap-5">
              {/* Padding, not margin: cosmos bans margin utilities. Matches the
                  text column's own offset so the icon stays on the title. */}
              <Box className={cn('shrink-0', index > 0 && 'pt-8')}>
                <Box className="size-11 items-center justify-center rounded-[12px] bg-od-bg-primary">
                  <Image src={prop.icon} alt="" className="size-6" />
                </Box>
              </Box>
              <Col
                className={cn(
                  'flex-1 gap-3',
                  index > 0 && 'border-t border-od-border-primary pt-8',
                )}
              >
                <Text
                  as="h3"
                  className="font-medium text-[20px] tracking-[-1px] text-od-content-primary"
                >
                  {prop.title}
                </Text>
                <Text className={BODY_COPY}>{prop.body}</Text>
              </Col>
            </Row>
          ))}
        </Col>
      </Col>
    </Row>
  </Box>
);

export default WhySubmitOnline;
